import { Box, Typography } from '@mui/material';
import lineSightLogo from 'assets/img/linesight_logo.png';
import { Link } from 'react-router-dom';

const NoAccessIndex = () => {
  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '70vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <img
        src={lineSightLogo}
        alt="scryb logo"
        style={{
          width: '30rem',
          maxWidth: '80svw',
          height: 'auto',
          margin: '1rem',
          marginBottom: '3rem'
        }}
      />
      <Typography variant="h4" gutterBottom>
        User does not have access to this page
      </Typography>
      <Typography variant="subtitle2" gutterBottom>
        Contact your system administrator for more information
      </Typography>
      <Link to={'/'}>Go Home</Link>
    </Box>
  );
};

export default NoAccessIndex;
